module.exports = __webpack_public_path__ + "static/img/game_list02.140e238b.jpg";